import { defineStore } from "pinia";
import type { NomesRotinas, PagesMenu, rotinasMenu, rotinasMenu } from "~/types/pagesMenu";
import type { TelasHarpiaWMS } from "~/composables/useSetMenusCollector";

export const useUserStore = defineStore(
	"userStore",
	() => {
		const userID = ref<number>(0);
		/** Nome de exibição (`DESCR_754`). Vazio até carregar da base. */
		const userName = ref<string>("");
		function setUserName(name: string) {
			userName.value = name?.trim() ?? "";
		}
		function setUserID(newID: number) {
			if (userID.value !== newID) {
				userName.value = "";
			}
			userID.value = newID;
		}

		const companiesNames = ref<string[]>([]);
		function setCompaniesNames(newCompanies: string[]) {
			companiesNames.value = newCompanies;
		}

		const companiesID = ref<string[]>([]);
		function setCompaniesID(newCompaniesID: string[]) {
			companiesID.value = newCompaniesID;
		}

		const companyID = ref<number>();
		function setCompanyID(newCompanyId: number) {
			companyID.value = newCompanyId;
		}

		const companyName = ref<string>("");
		function setCompanyName(newCompanyName: string) {
			companyName.value = newCompanyName;
		}

		const userType = ref<string>();
		function setUserType(type: string) {
			userType.value = type;
		}

		const authenticated = ref(false);

		function setAuthStatus(newStatus: boolean) {
			authenticated.value = newStatus;
		}

		const authenticationLogout = ref(false);

		function setAuthenticationLogout(newStatus: boolean) {
			authenticationLogout.value = newStatus;
		}

		const userRoutines = ref<PagesMenu[]>([]);

		function setUserRoutines(newRoutines: PagesMenu[]) {
			userRoutines.value = newRoutines;
		}

		const currentPageName = ref<string>("");

		function setCurrentPageName(page: string) {
			currentPageName.value = page;
		}

		const menuSelected = ref<"" | rotinasMenu>("");
		function setMenuSelected(newMenu: rotinasMenu) {
			menuSelected.value = newMenu;
		}

		const rotinasUsuario = ref<NomesRotinas[]>([]);
		function setRotinasUsuario(newRotinas: NomesRotinas[]) {
			rotinasUsuario.value = newRotinas;
		}




		return {
			companiesNames,
			setCompaniesNames,
			companiesID,
			setCompaniesID,
			userID,
			setUserID,
			userName,
			setUserName,
			companyID,
			setCompanyID,
			userType,
			setUserType,
			authenticated,
			setAuthStatus,
			authenticationLogout,
			setAuthenticationLogout,
			userRoutines,
			setUserRoutines,
			companyName,
			setCompanyName,
			currentPageName,
			setCurrentPageName,
			menuSelected,
			setMenuSelected,
			rotinasUsuario,
			setRotinasUsuario,
		};
	},
	{
		persist: {
			// storage: localStorage,
		},

	}
);

// //@ts-ignore
// if (import.meta.hot) {
//   //@ts-ignore
//   import.meta.hot.accept(acceptHMRUpdate(useAllowedMenus, import.meta.hot));
// }
